<template>
  <div class="table-responsive d-inline cohort-table" style="position: relative;">
    <table class="table mb-0"
    v-blur="{
              isBlurred: isBlurred,
              opacity: 1,
              filter: 'blur(5px)',
              transition: 'all .3s linear',
            }"
    v-bind:class="{ blockInteraction: isBlurred }"
    :style="isBlurred ? 'pointer-events: none;' : ''"
    >
      <thead>
        <tr>
          <th style="max-width: 40px">Period</th>
          <th
            style="padding-right: 0px !important"
            class="px-0 text-center"
            v-for="index in interval"
            v-bind:key="index"
          >
            {{ period }} {{ index - 1 }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(list, d) in cohort" v-bind:key="d">
          <td class="fs-12" style="max-width: 40px">
            {{ formatDatetime(d) }}
          </td>
          <template v-for="(v, k) in list">
            <td
              class="fs-12 px-0 text-center pr-0"
              :style="
                `border-right: 1px var(--background) solid;background-color: ` +
                (v === 0
                  ? 'var(--background)'
                  : v === -1
                  ? 'var(--background)'
                  : getThemeColor(k === 0 ? 1 : Number(v / largestVal) * 0.5))
              "
              v-bind:key="k"
            >
              <div
                :class="{ 'text-white': k === 0 && v !== 0 }"
                class="tooltip-pop"
                :rel="v + ' visitors'"
                v-if="v !== -1"
              >
                {{
                  (list[0] === 0 ? 0 : ((v / list[0]) * 100).toFixed(0)) + '%'
                }}
              </div>
            </td>
          </template>
        </tr>
      </tbody>
    </table>
    <div v-if="isLoaded && isBlurred" @click="redirectToCheckout()" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); background: rgba(var(--main-color), 1);" class="text-white font-weight-bold rounded py-2 px-3 upgrade-full-access">Upgrade to have full access</div>
  </div>
</template>

<script>

/* eslint-disable */
export default {
  props: ['interval', 'period'],

  components: {},
  beforeMount(){
    this.assignValuesForShare()
  },
  mounted() {
    // if (!this.interval) this.interval = 7
    // if (!this.period) this.period = 'DAY'
    setTimeout(() => {
      this.loadData()
    }, 800);
  },
  watch: {},
  data: function () {
    return {
      cohort: null,
      largestVal: 0,
      tempjwt:'',
      tempWidgetId:0,
      secretPosition:17,
      isShareSession:false,
      isLoaded: false,
      isBlurred: false
    }
  },
  methods: {
    redirectToCheckout() {
      window.location.href = 'https://app.howuku.com/checkout'
    },
    secondMax(oarr) {
      var arr = [].concat(oarr)
      var max = Math.max.apply(null, arr) // get the max of the array
      arr.splice(arr.indexOf(max), 1) // remove max from the array
      return Math.max.apply(null, arr) // get the 2nd max
    },
    getThemeColor(opacity) {
      return opacity === 0
        ? 'rgba(0,0,0,0)'
        : 'rgba(' + localStorage.getItem('--main-color') + ',' + opacity + ')'

      // '#dadce0'
    },
    changePeriod: function (value) {
      this.option = value
      // console.log(value)
      this.clearState = true
      this.loadData()
      this.clearState = false
    },
    formatDatetime(s) {
      function getMonthDateRange(year, month) {
        var startDate = moment([year, month - 1]).format('MMM DD')
        var endDate = moment(startDate).endOf('month').format('MMM DD')
        return startDate + ' - ' + endDate
      }

      if (this.period === 'DAY') return moment(s).format('MMM DD')
      if (this.period === 'WEEK') {
        // mysql week starts at 0
        // moment week starts at 1
        let week = Number(s) + 1
        return (
          this.$userTimeNow().week(week).startOf('week').format('MMM DD') +
          ' - ' +
          this.$userTimeNow().week(week).endOf('week').format('MMM DD')
        )
      }
      if (this.period === 'MONTH')
        return getMonthDateRange(this.$userTimeNow().format('YYYY'), s)
    },
    loadData: function () {
      // console.log(this.period)
      // console.log(this.interval)
      this.isBlurred = this.$isFreePlan.includes(this.$session.get('paid_plan')) || this.$isLegacyFreePlan.includes(this.$session.get('paid_plan'))

      this.$http
        .get(
          process.env.API_ENDPOINT +
            '/cohort/' +
            ((!this.isShareSession) ? this.$session.get('widget_id') :this.tempWidgetId)+
            '/' +
            (this.period || 7).toString() +
            '/' +
            (this.interval || 'day').toString() ,{
              headers:{
                'jwt':this.tempjwt
              }
            }
        )
        .then((result) => {
          let x = result.data

          this.cohort = {}
          this.largestVal = 0

          if (this.period === 'DAY') {
            var getDaysArray = function (s, e) {
              for (
                var a = [], d = new Date(s);
                d <= e;
                d.setDate(d.getDate() + 1)
              ) {
                if (d) a.push(new Date(d))
              }
              return a
            }
            let arr = getDaysArray(
              this.$userTimeNow().add(-7, 'd').toDate(),
              this.$userTimeNow().toDate()
            )
            arr.pop()
            arr.map((d) => {
              if (moment(d).format('YYYY-MM-DD'))
                this.cohort[moment(d).format('YYYY-MM-DD')] = Array(
                  this.interval
                ).fill(0)
            })
          }

          for (let i = 0; i < x.length; i++) {
            let dates = x[i].dates.split(',')

            for (let d = 0; d < dates.length; d++) {
              let diff = 0
              if (this.period === 'DAY') {
                let d1 = moment(dates[0])
                let d2 = moment(dates[d])
                if (!d1) continue
                diff = d2.diff(d1, 'days')
              } else {
                diff = dates[d] - dates[0]
              }

              if (!this.cohort[dates[0]])
                this.cohort[dates[0]] = Array(this.interval).fill(0)
              if (!this.cohort[dates[d]])
                this.cohort[dates[d]] = Array(this.interval).fill(0)
              if (!this.cohort[dates[0]][diff]) this.cohort[dates[0]][diff] = 0

              this.cohort[dates[0]][diff] += 1
              this.cohort[dates[d]][0] += 1
            }
          }
          function sortObject(obj) {
            return Object.keys(obj)
              .sort()
              .reduce(function (result, key) {
                result[key] = obj[key]
                return result
              }, {})
          }
          this.cohort = sortObject(this.cohort)

          let counter = 0
          for (let i in this.cohort) {
            this.cohort[i].splice(this.cohort[i].length - counter, counter)
            for (let x = 0; x < counter; x++) {
              this.cohort[i].push(-1)
            }

            if (counter >= this.interval) delete this.cohort[i]
            counter++
          }

          for (let i in this.cohort) {
            let max = this.secondMax(this.cohort[i])

            if (max > this.largestVal) {
              this.largestVal = max
            }
          }
        this.isLoaded = true
        })
    },
    assignValuesForShare(){
      if(!this.$route.params.encryptedParam){
        this.tempjwt = localStorage.getItem('jwt')
        this.tempWidgetId = this.$session.get('widget_id')
      }else{
        //if is not share session then assign 
        this.isShareSession = true
        this.tempjwt = window.TEMP_JWT
        this.tempWidgetId = window.TEMP_WIDGET_ID
      }
    },
  },
}
</script>
<style scoped>
.upgrade-full-access:hover {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/CohortGraph.vue